<template>
  <v-dialog v-model="show" persistent max-width="600px">
    <v-card >
      <v-toolbar color="light-green lighten-3" dark>
        <v-toolbar-title class="headline"
          >Lägg till extraanpassning för {{classen}}</v-toolbar-title
        >
      </v-toolbar>
      <v-card-text>
        <v-container>
          <v-flex>
                 <v-flex >
              <v-select
                v-model="NewExtra.ClassAdaptations"
                :items="kategorier"
                attach
                multiple
                chips
                label="Kategori"
                hint="Vilken extraanpassninga använder du?"
                persistent-hint
              ></v-select>
            </v-flex>
    
          </v-flex>
        </v-container>
      </v-card-text>
      <v-card-actions class="mtop">
        <v-spacer></v-spacer>
        <v-btn dark color="red darken-1" @click="show = false"> Stäng </v-btn>
     
        <v-btn color="green lighten-1" text dark @click="change()" >
          {{btnText}} extraanpassning
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "newClassExtra",

  watch: {
     
  },

  computed: {
    show: {
      get() {
        if(this.oldExtra!=null)
        if(this.oldExtra.name!=this.name)
        if (this.oldExtra != null ) {
          if (this.oldExtra.hasOwnProperty('class')) {
          if (this.classId== this.oldExtra.class) {
             this.oldAdoptations  = [...new Set( this.oldExtra.ClassAdaptations)];

                   this.NewExtra = this.oldExtra;
            this.btnText="Uppdatera"
          this.update = true;
          if(this.oldExtra.hasOwnProperty("name"))
          this.name = this.oldExtra.name;
          else
          {
          this.name = "";
          this.oldExtra.name =""
          }
        }
        
          }
          }
          else
          {
            this.NewExtra={schoolId:this.schoolId , ClassAdaptations: []}
            
            this.btnText="Skapa"
          this.update = false;
          }
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  created() {
 
  },
  props: {
    membernameandId: Array,
    oldExtra: Object,
    schoolId: String,
    classen: String,
    classId: String,
    value: Boolean,
  },
  data() {
    return {
      update: false,
      name: "",
      oldAdoptations: [],
      kategorier: [
        "Tydlig start och avslut på lektionen.",
        "Kortare genomgångar",
        "Varierande genomgångsformer",
        "Bestämda platser",
        "Glasspinnar (bestämmer vem som får svara på frågor slumpmässigt)",
      ],
      NewExtra: {
        schoolId: this.schoolId,
         ClassAdaptations: [],
         teacherIds:[]
      },
      locfun: null,
      btnText: "Skapa",
    };
  },

  methods: {
    ...mapActions("extra", ["createExtra", "saveExtra"]),
    ...mapActions(["showSuccessSnackbar"]),

    change() {
   if (this.update == false) 
     {
         this.NewExtra.class = this.classId;
         this.NewExtra.teacherIds=[]
         this.NewExtra.ClassAdaptations.forEach(adap => {
           this.NewExtra.teacherIds.push("")
         });
         this.NewExtra.classLevel = true;
        this.NewExtra.name= this.classen;
      this.createExtra(this.NewExtra);
      this.showSuccessSnackbar(
        "Extraanpassning för  " + this.NewExtra.name + " är skapad!"
      );
      } else {


// Fixar så det är rätt teacherids och rätt antal

  let newteacherIDs=[]
           //console.log(this.oldAdoptations.length)

          // checkagainstOld= checkagainstOld.flat(Infinity);
         if(this.oldAdoptations.length> this.NewExtra.ClassAdaptations.length)
 {
  for (let i = 0; i < this.oldAdoptations.length; i++) {
         if(this.NewExtra.ClassAdaptations.includes(this.oldAdoptations[i]))    
			{
           let place= this.NewExtra.ClassAdaptations.findIndex(b1 => b1 == this.oldAdoptations[i])
           newteacherIDs.splice(place, 0, this.NewExtra.teacherIds[i]);
          
           }
            //  else if(this.NewExtra.ClassAdaptations[i]==null)
          // newteacherIDs.push("")          
          }
 }
 else if(this.oldAdoptations.length< this.NewExtra.ClassAdaptations.length)
 {
   for (let i = 0; i < this.NewExtra.ClassAdaptations.length; i++) {
     //console.log(this.oldAdoptations[i])
           if(this.NewExtra.ClassAdaptations.includes(this.oldAdoptations[i]))    
			{
           let place= this.NewExtra.ClassAdaptations.findIndex(b1 => b1 ==this.oldAdoptations[i])
           newteacherIDs.splice(place, 0, this.NewExtra.teacherIds[i]);
           }
           else
          newteacherIDs.push("")          
          }
 }
 
//console.log("OLD "+this.oldAdoptations)
//console.log(this.NewExtra.ClassAdaptations)
//console.log(newteacherIDs)
//console.log(this.NewExtra.teacherIds)
this.NewExtra.teacherIds=newteacherIDs;
this.oldAdoptations=this.NewExtra.ClassAdaptations;

        this.saveExtra(this.NewExtra);
        this.showSuccessSnackbar(
          "Extraanpassning för " + this.NewExtra.name + " är updaterad!"
        );
      }
       if (this.oldExtra == null) {
        this.NewExtra = {};
     }
  this.btnText="Skapa"
      this.show = false;
    },
  },
};
</script>
<style >
.mtop{
  margin-top: 200px !important;
}
</style>